import {
  CLEAR_CREDENTIALS,
  CLEAR_OPTIONS,
  SET_CREDENTIALS,
  ADD_MEDIA,
  CLEAR_MEDIA,
  UPDATE_OPTIONS,
  REMOVE_MEDIA,
  ADD_RESPONSE,
  CLEAR_RESPONSE,
  SELECT_DEFAULT_TRANSFORMATIONS,
} from './constants/actionTypes';
import { Credentials, MediaState, OptionsState, ConsoleResponseState } from './types';

export const clearCredentials = () => ({ type: CLEAR_CREDENTIALS });
export const setCredentials = (payload: Credentials) => ({ type: SET_CREDENTIALS, payload });
export const clearOptions = () => ({ type: CLEAR_OPTIONS });
export const updateOptions = (payload: OptionsState) => ({ type: UPDATE_OPTIONS, payload });
export const selectDefaultTransformations = (payload: { key: string; value: boolean }) => ({ type: SELECT_DEFAULT_TRANSFORMATIONS, payload });
export const addMedia = (payload: MediaState) => ({ type: ADD_MEDIA, payload });
export const removeMedia = (payload: { index: number }) => ({ type: REMOVE_MEDIA, payload });
export const clearMedia = () => ({ type: CLEAR_MEDIA });
export const addResponse = (payload: ConsoleResponseState) => ({ type: ADD_RESPONSE, payload });
export const clearResponse = () => ({ type: CLEAR_RESPONSE });
